import * as React from 'react';
import { observer } from 'mobx-react';

// types
import { PostStats } from '@sprinklr/stories/post/Post';
import { NativeEngagementProps } from './types';

// components
import NativeIcon from '../../Bits/NativeIcon';
import NativeFlex from '../../Bits/NativeFlex';
import { StyledNativeEngagement } from './styledComponents';

// constants
import { ENGAGEMENT_ORDER } from './constants';

// helpers
import getPrettyNumber from '../../../../utils/Number/NumberUtils';
import { getNumberString } from '../../Helpers';
import { getStatIcon } from './helpers';

const NativeEngagement: React.FC<NativeEngagementProps> = ({
    snStats,
    snType,
    hideZero = true,
    numberFormat = { type: 'pretty', decimals: 1 },
}) => {
    const engagementItems = snStats
        ? Object.keys(snStats)
              .map(stat => {
                  const icon = getStatIcon(stat as PostStats, snType);
                  if (!icon) {
                      return;
                  }
                  return {
                      icon,
                      value: snStats[stat],
                      stat,
                  };
              })
              .filter(item => item)
              .sort((a, b) => {
                  return ENGAGEMENT_ORDER.indexOf(a.stat) - ENGAGEMENT_ORDER.indexOf(b.stat);
              })
        : [];

    if (!engagementItems.length) {
        return <div />;
    }
    return (
        <StyledNativeEngagement gap='xl' left middle noGrow style={{ flexWrap: 'wrap' }}>
            {engagementItems.map((item, index) => {
                const { value, suffix } = getPrettyNumber(item.value, numberFormat.decimals, false);
                return (
                    <React.Fragment key={index}>
                        {((hideZero && value) || !hideZero) && (
                            <NativeFlex data-id-stat={item.stat} key={index} middle gap='m' noGrow>
                                <NativeIcon value={item.icon} size='m' />
                                {value && (
                                    <>
                                        {numberFormat.type === 'pretty' && (
                                            <span data-id-number-format='pretty'>
                                                {value}
                                                {suffix}
                                            </span>
                                        )}
                                        {numberFormat.type === 'default' && (
                                            <span data-id-number-format='default'>
                                                {getNumberString(item.value)}
                                            </span>
                                        )}
                                    </>
                                )}
                            </NativeFlex>
                        )}
                    </React.Fragment>
                );
            })}
        </StyledNativeEngagement>
    );
};

NativeEngagement.displayName = 'NativeEngagement';
export default observer(NativeEngagement);
